import { render } from "./ListePropositionReponsePage.vue?vue&type=template&id=187c5918&ts=true"
import script from "./ListePropositionReponsePage.vue?vue&type=script&lang=ts"
export * from "./ListePropositionReponsePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__